import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { selectIsHost } from "../../selectors";

/** Sends participants (who cannot change the catalog) back to the songs, once the session is known. */
const RequireHost = ({ children }) => {
  const isHost = useSelector(selectIsHost);
  const isLoaded = useSelector((state) => state.session.isLoaded);
  if (!isLoaded) return null;
  return isHost ? children : <Navigate to="/songs" replace />;
};

export default RequireHost;
